export default "__VITE_ASSET___eK3zNBW__"